import * as yup from "yup";

import { PromotionTypeEnum } from "@krea/shared/types/common";

import type { IPromotionInput } from "@/features/lender-responses/types/lender-response";

export const bidPromotionSchema: yup.ObjectSchema<IPromotionInput> = yup
  .object()
  .shape({
    // A month count, and mandatory — except for EU_LOAN, which is a flag with no
    // duration. Keep the requirement strict for every other type.
    value: yup
      .number()
      .positive()
      .integer()
      .moreThan(0, "Must be at least 1")
      .when("type", {
        is: PromotionTypeEnum.EU_LOAN,
        then: (schema) => schema.strip(),
        otherwise: (schema) => schema.required("Required"),
      }),
    type: yup.string().oneOf(Object.values(PromotionTypeEnum)).required(),
  });
